import { style } from "@vanilla-extract/css";
import { pagePadding } from "plos/src/layouts";
import { vars } from "plos/src/styles/theme.css";

export const fixturePage = style([
  {
    display: "grid",
    gap: vars.space.m,
  },
  pagePadding,
]);
